import './vendor';
import './helpers';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import lazyLoading from './modules/lazyLoading';
import Vivus from '../../node_modules/vivus/dist/vivus.js';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')




ieFix();
vhFix();

lazyLoading.init();



let iconAnimation = document.getElementsByClassName("svgAnimation");

for (let i = iconAnimation.length - 1; i >= 0; i--) {
	new Vivus(
	  iconAnimation[i],
	  {
	    type: 'delayed',
	    duration: 100,
	    animTimingFunction: Vivus.EASE
	  }
	);
}

/*

let btnMenu = document.getElementById("btn-menu");
let nav = document.getElementById("nav");
let header = document.getElementById("header");

btnMenu.onclick = () => {
	 nav.classList.toggle("is-active");
	 header.classList.toggle("is-active");
}

document.querySelectorAll('.scroll-to-link').forEach(link => {

    link.addEventListener('click', function(e) {
        e.preventDefault();

        let href = this.getAttribute('href').substring(1);

        const scrollTarget = document.getElementById(href);

        const elementPosition = scrollTarget.getBoundingClientRect().top;
        const offsetPosition = elementPosition;

        window.scrollBy({
            top: offsetPosition,
            behavior: 'smooth'
        });
    });
});

*/
let $status = $('.pagingInfo');
let $slickElement = $('.slider');

$slickElement.slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	prevArrow: $("#main-slider-prev"),
	nextArrow: $("#main-slider-next"),
});

$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.html('<small>0' + i + '</small>/ 0' + slick.slideCount);
});


$('.company-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	appendDots: $('.slick-dots-custom'),
	prevArrow: $("#company-slider-prev"),
	nextArrow: $("#company-slider-next")
});

/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/build/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});

$(".filterbtn").click(function() {
	$(this).toggleClass("is-active");
	$(".filterhide").toggleClass("is-active");
	$(".filter").toggleClass("is-active");
	$(".catalog").toggleClass("is-active");
	$(".catalogblock__wrapper").toggleClass("is-active");
});


$(".filter__title").click(function() {
	$(this).toggleClass("is-active");
	$(this).parents(".filter__item").find(".filter__wrap").slideToggle();
});

$("#menu").click(function() {
	$(".header__nav").toggleClass("is-active");
});


$(".tabs-block__mobiletab").click(function() {
	$(this).parents(".tabs-block__item").find(".tabs-block__wrap").slideToggle();
});


// ПЛЮС И МИНУС В ФОРМЕ

let input = document.querySelector("#input");
let plus = document.querySelector("#plus");
let minus = document.querySelector("#minus");
let countProduct = document.querySelector("#count-product");

let inputValue = "";

plus.onclick = () => {
	inputValue++;
	input.value = inputValue;
	countProduct.value = inputValue
}

minus.onclick = () => {
	input.value = inputValue;
	if (input.value > 0) {
		inputValue--;
	}
	countProduct.value = inputValue
}




$(".tabs-block__item").not(":first").hide();
$(".tabs-block .tabs-block__tab").click(function() {
	$(".tabs-block .tabs-block__tab").removeClass("active").eq($(this).index()).addClass("active");
	$(".tabs-block__item").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("active");



$('.product-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	appendDots: $('.slick-dots-custom'),
	prevArrow: '<button type="button" class="btn-slider prev"><img src="/assets/build/images/sprites/svg/prev.svg"></button>',
	nextArrow: '<button type="button" class="btn-slider next"><img src="/assets/build/images/sprites/svg/next.svg"></button>',
	asNavFor: '.product-slider-thumb',
});

$('.product-slider-thumb').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	vertical: true,
	asNavFor: '.product-slider',
	focusOnSelect: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				vertical: false,
		    }
		}
	]
});


$(".scroll").on("click","a", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});


/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});



//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "/assets/build/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});